export const RFM_LOYALTY_LEVEL = {
  source: 'Rfm',
  typeCode: 'Calculated',
} as const;
